import React from 'react'
import "./Projects.css"
import { BsGithub } from "react-icons/bs";
import { BiLinkExternal } from "react-icons/bi";

const ReversedProject = (props) => {
  return (
    <div className="project">
    <div className="project-container">
      
      <div className="project-info">
        <h3>{props.projectName}</h3>
        <p className="about-text">{props.aboutProject}</p>
      
        
      </div>
      <div className="img-box">
        <img className="project-image" src={props.image} alt="project" />
        <div className="img-text2">
        <div className="project-links">
        <a
          className="demo-link"
          target="_blank"
          href={props.githubLink}
        >
          <BsGithub />
        </a>
        <a
          className="demo-link"
          target="_blank"
          href={props.liveLink}
        >
        <BiLinkExternal />
        </a>
        </div>
        </div>
      </div>
    </div>

    </div>
  )
}

export default ReversedProject